<template>
  <div class="login-page">
    <el-card class="login-card" shadow="always">
      <div class="login-head">
        <span class="login-mark">旅</span>
        <h1>管理后台登录</h1>
        <p>仅用于业务数据管理，不配置小程序结构。</p>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-position="top" @keyup.enter.native="submit">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入账号" autocomplete="username" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" autocomplete="current-password" show-password />
        </el-form-item>
        <el-button class="login-button" type="primary" :loading="loading" @click="submit">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from "../api/auth";
import adminStore from "../store/admin";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      form: {
        username: process.env.NODE_ENV === "development" ? "admin" : "",
        password: process.env.NODE_ENV === "development" ? "123456" : ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.$message.error("请填写账号和密码");
          return;
        }
        this.loading = true;
        try {
          const res = await login(this.form, { showErrorMessage: false });
          window.localStorage.setItem("admin_token", res.data.token);
          adminStore.setAdmin(res.data.user || {});
          this.$message.success("登录成功");
          this.$router.replace(this.$route.query.redirect || "/dashboard");
        } catch (error) {
          this.$message.error(error.message || "登录失败，请稍后重试");
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>
